import React from 'react';
import About from '../About';
const AboutPage = () => {
  return (
    <div>
      <About/>
    </div>
  );
};

export default AboutPage;